import { AutogenModelEdiProfile, AutogenRowEdiProfile } from "./autogen/AutogenModelEdiProfile";

export class ModelEdiProfile extends AutogenModelEdiProfile<RowEdiProfile> {
	constructor() {
		super(RowEdiProfile);
	}
}

export class RowEdiProfile extends AutogenRowEdiProfile {
}